import { render } from "./ReportGeneralSection.vue?vue&type=template&id=196ec9b0"
import script from "./ReportGeneralSection.vue?vue&type=script&lang=js"
export * from "./ReportGeneralSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__